import React, { useEffect } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { PACKAGE_NAME } from './common/constants';
import { trialBannerEntryPoint } from './entrypoint';

type Props = {
	isProjectSimplified: boolean;
};
const entryPointParams = {};
export const TrialBannerExperiment = (props: Props) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		trialBannerEntryPoint,
		entryPointParams,
	);

	useEffect(() => {
		// Preloads data for the onboarding modal on mount
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id="jiraBusinessMonetizationTrialBanner"
			packageName={PACKAGE_NAME}
			teamName="program-moon"
			entryPointReferenceSubject={entryPointReferenceSubject}
			runtimeProps={{ isProjectSimplified: props.isProjectSimplified }}
			errorFallback="unmount"
		/>
	);
};
